<template>
  <div>
    <v-toolbar class="toolbar-element" light absolute flat height="90em">
      <v-toolbar-title class="toolbar-title">Pagos a {{ informe.tipoPersonal == 0 ? 'Jugadores' : 'Cuerpo Técnico'}}</v-toolbar-title>
    </v-toolbar>
    <div v-if="loading" class="spacing-top">
      <v-flex offset-xs5 pa-5>
        <v-progress-circular :size="100" :width="5" color="primary" indeterminate></v-progress-circular>
      </v-flex>
    </div>
    <div v-else class="spacing-top">
      <v-card>
        <v-layout row wrap>
          <v-flex xs12 md3 pt-4 pl-4 ml-2 pb-4>
                <div v-if="$store.getters.isSafRole"><b>Club:</b> {{ informe.club.nombre }}</div>
                <div><b>Temporada:</b> {{ informe.temporada.nombre }}</div>
                <div><b>Período:</b> {{ informe.mesDisplay }}</div>
                <div><b>Fecha de vencimiento:</b> {{ informe.fechaVencimiento }}</div>
                <div><b>Estado:</b> {{ informe.estadoDisplay }}</div>
                <div><b>Pagos cargados:</b> {{ informe.cantidadPagos }} / {{ informe.cantidadCondiciones }}</div>

          </v-flex>
          <v-divider vertical></v-divider>
          <v-flex xs12 pl-4 md3 pt-4 pb-4>
              <span :class="informe.estadoDeclaracionJurada === 'A subsanar' ? 'documento-error' : ''">
                Declaración jurada: {{ informe.estadoDeclaracionJurada }}</span>
                <br/>
              <span :class="informe.estadoAnexoDeuda === 'A subsanar' ? 'documento-error' : ''">Anexo 1 - Deudas: {{ informe.estadoAnexoDeuda }}</span>
                <br/>
              <span :class="informe.estadoComprobanteGeneral === 'A subsanar' ? 'documento-error' : ''">
                Comprobantes de pagos generales: {{ informe.estadoComprobanteGeneral }}</span>
          </v-flex>
          <v-flex xs12  pl-4 md2 pt-4 pb-4>
            <adjuntos-informe-popup :adjuntos="adjuntos" @updatedAdjuntos="updatedAdjuntos" ref="adjuntosPopup">
            </adjuntos-informe-popup>
          </v-flex>
          <v-divider vertical></v-divider>
          <v-flex xs12 md3  pl-4 pt-4 pr-2 pb-4 v-if="$store.getters.isClubRole">
            <v-layout column wrap>
              <v-btn @click="presentar" color="primary" :disabled="!informe.canPresentar">
                Presentar
              </v-btn>
              <v-btn slot="activator" color="primary" @click="downloadExcel">Descargar Reporte Salarial</v-btn>
              <v-btn slot="activator" color="primary" @click="precargarInforme" v-if="informe.canPrecargar && $store.getters.isClubRole">Precargar Informe</v-btn>
            </v-layout>
          </v-flex>
          <v-flex xs12 md3  pl-4 pt-4 pr-4 pb-4 v-else>
            <v-layout column wrap>
              <v-btn @click="aprobarInforme" color="green" :disabled="!informe.canApprove">Aprobar</v-btn>
              <v-btn @click="rechazarInforme" color="red" :disabled="!informe.canReject">Rechazar</v-btn>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>

      <v-divider></v-divider>
      <ConfirmationDialog ref="confirmDelete" :function-yes="bindingFunction" title="¿Borrar pago?" :text="textoConfirm"></ConfirmationDialog>
      <rechazar-informe-popup ref="subsanar" @rechazado="volverAInformes"></rechazar-informe-popup>
      <precarga-informe-popup ref="precargar" @precargado="refreshInforme" v-if="informe.canPrecargar && $store.getters.isClubRole"></precarga-informe-popup>

      <pagos-table @viewPago="viewPago" ref="tablaPagos"
      @aprobarPago="aprobarPago" @rechazarPago="rechazarPago" @borrarPago="confirmBorrarPago"></pagos-table>
      <v-btn @click="volverAInformes">Volver</v-btn>
    </div>

    <creacion-pago-popup-form v-if="viewDialog" :dialog="viewDialog" @cerrarModal="cerrarModal" :pagoId="pagoId" :key="creacionPagoPopupKey"
      @aprobarPago="aprobarPago" @rechazarPago="rechazarPago" ref="popupPagos" @updatedPago="refreshInforme">
    </creacion-pago-popup-form>
    <v-btn v-if="canAddPago" app dark fixed fab bottom right class="add-button" @click="pagoNuevo">
      <v-icon>add</v-icon>
    </v-btn>
  </div>

</template>

<script>
import PagosTable from '../components/PagosTable'
import CreacionPagoPopupForm from '../components/CreacionPagoPopupForm'
import AdjuntosInformePopup from '../components/AdjuntosInformePopup'
import ConfirmationDialog from '../../../common/ui/ConfirmationDialog'
import RechazarInformePopup from '../components/RechazarInformePopup.vue'
import PrecargaInformePopup from '../components/PrecargaInformePopup.vue'
import { downloadFileMixin } from '../../../mixins/downloadFileMixin'

export default {

  mixins: [
    downloadFileMixin
  ],

  components: {
    PagosTable,
    ConfirmationDialog,
    CreacionPagoPopupForm,
    RechazarInformePopup,
    PrecargaInformePopup,
    AdjuntosInformePopup
  },

  data () {
    return {
      viewDialog: false,
      loading: true,
      pagoId: null,
      bindingFunction: null,
      textoConfirm: null,
      path: `/informe/${this.$route.params.id}`,
      aprobarPath: `/informe/aprobar/${this.$route.params.id}`,
      rechazarPath: `/informe/rechazar/${this.$route.params.id}`,
      informe: {},
      adjuntos: [],
      tieneNotificaciones: false,
      canEdit: false,
      creacionPagoPopupKey: 0
    }
  },

  methods: {
    changeComprobanteStatus (estado) {
      const path = `informe/comprobante/corregir/${this.informeId}/${estado}`
      this.axios
        .put(path)
        .then(response => { this.fetchData() })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    volverAInformes () {
      const JUGADORES = 0
      const routeName = this.informe.tipoPersonal === JUGADORES ? 'informesJugadores' : 'informesCuerpoTecnico'
      this.$router.push({ name: routeName })
    },
    changeDeclaracionStatus (estado) {
      const path = `informe/declaracion/corregir/${this.informeId}/${estado}`
      this.axios
        .put(path)
        .then(response => { this.fetchData() })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    changeAnexoStatus (estado) {
      const path = `informe/anexo/corregir/${this.informeId}/${estado}`
      this.axios
        .put(path)
        .then(response => { this.fetchData() })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    aprobarInforme () {
      this.axios
        .put(this.aprobarPath)
        .then(response => {
          this.volverAInformes()
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    rechazarInforme () {
      this.$refs.subsanar.openDialog()
    },
    precargarInforme () {
      this.$refs.precargar.openDialog()
    },
    viewPago (pagoId) {
      this.pagoId = pagoId
      this.viewDialog = true
    },
    pagoNuevo () {
      this.pagoId = null
      this.viewDialog = true
    },
    confirmBorrarPago (pagoId, fullname) {
      this.pagoId = pagoId
      this.bindingFunction = this.borrarPago
      this.textoConfirm = `¿Desea eliminar el pago para ${fullname}?`
      this.$refs.confirmDelete.openDialog()
    },
    borrarPago () {
      this.axios
        .delete(`pago/delete/${this.pagoId}`)
        .then(response => {
          this.refreshInforme()
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    cerrarModal (pagoCreadoId) {
      if (pagoCreadoId) {
        this.refreshInforme()
        this.creacionPagoPopupKey += 1
        this.pagoId = pagoCreadoId
      } else {
        this.viewDialog = false
      }
    },
    refreshInforme () {
      this.fetchData()
      this.$refs.tablaPagos.refreshTable()
    },
    presentar () {
      this.axios
        .put(`informe/presentar/${this.$route.params.id}`)
        .then(response => {
          this.volverAInformes()
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    editar () {
      this.$router.push({ name: 'editarInformePagos', params: { id: this.$route.params.id } })
    },
    setearAdjuntos (data, resetAdjuntos) {
      this.adjuntos = [data.declaracionJurada, data.anexoDeuda, data.comprobanteGeneral]
      if (resetAdjuntos) {
        this.$refs.adjuntosPopup.resetComponent()
      }
    },
    updatedAdjuntos () {
      this.fetchData(true)
    },
    fetchData (resetAdjuntos) {
      this.axios
        .get(this.path)
        .then(response => {
          this.canEdit = response.data.canEdit
          this.tieneNotificaciones = response.data.tieneNotificaciones
          this.informe = response.data
          this.setearAdjuntos(response.data, resetAdjuntos)
          this.loading = false
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    postCambioEstadoDePago () {
      this.fetchData()
      this.refreshInforme()
      if (this.$refs.popupPagos) {
        this.$refs.popupPagos.cerrarModal()
      }
    },
    aprobarPago (pagoId) {
      const aprobarPath = `pago/aprobar/${pagoId}`
      this.axios
        .put(aprobarPath)
        .then(response => {
          this.postCambioEstadoDePago()
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    rechazarPago (pagoId) {
      const rechazarPath = `pago/rechazar/${pagoId}`
      this.axios
        .put(rechazarPath)
        .then(response => {
          this.postCambioEstadoDePago()
        })
        .catch(error => { this.$store.commit('setErrorMsg', error) })
    },
    formatDate (dateFromAPI) {
      if (!dateFromAPI) return null
      let dateParts = dateFromAPI.split('/')
      return new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0])
    },
    getFilteringPath () {
      const mes = this.formatDate(this.informe.mes)
      const firstDay = new Date(mes.getFullYear(), mes.getMonth(), 1).toISOString().split('T')[0]
      const lastDay = new Date(mes.getFullYear(), mes.getMonth() + 1, 0).toISOString().split('T')[0]
      return `fromDate=${firstDay}&toDate=${lastDay}`
    },
    getExcelPath () {
      const JUGADORES = 0
      const tipoPersonal = this.informe.tipoPersonal === JUGADORES ? 'jugadores' : 'cuerpo-tecnico'
      return `condiciones/${tipoPersonal}/xls` + '?' + this.getFilteringPath()
    },
    getFilenamePrefix () {
      const JUGADORES = 0
      const tipoPersonal = this.informe.tipoPersonal === JUGADORES ? 'jugadores' : 'cuerpo_tecnico'
      return `condiciones_${tipoPersonal}`
    }
  },

  computed: {
    informeId () {
      return this.$route.params.id
    },
    canAddPago () {
      return this.$store.getters.isClubRole && this.canEdit && this.informe.cantidadPagos !== this.informe.cantidadCondiciones
    }
  },

  created () {
    this.fetchData()
  }
}
</script>

<style scoped>
  .spacing-top {
    margin-top: 6em;
  }
  .documento-error {
    color: red;
  }
</style>
